import React from 'react';
import { ChatBubble, ChatLamp } from './ChatBrand';
import ChatIcon from './ChatIcon';
import { RichText } from './chatConfig';
import sparklesIcon from '../../styles/assets/img/chat/sparkles.svg';

/**
 * Empty-conversation state: the intro card followed by the suggested questions.
 */
export default function ChatStarter({ introTitle, introMessage, suggestionsTitle, suggestions, onSuggestion }) {
    return (
        <div className="chat-starter">
            <div className="chat-message-row chat-message-row-bot">
                <ChatBubble className="chat-intro">
                    <div className="chat-intro-header">
                        <ChatLamp />
                        <h2 className="chat-intro-title">{introTitle}</h2>
                    </div>
                    {introMessage.map((paragraph) => (
                        <p key={paragraph}><RichText text={paragraph} /></p>
                    ))}
                </ChatBubble>
            </div>

            {suggestions.length > 0 && (
                <div className="chat-suggestions">
                    <div className="chat-suggestions-header">
                        <ChatIcon src={sparklesIcon} className="chat-sparkles-icon" />
                        <span>{suggestionsTitle}</span>
                    </div>
                    <div className="chat-suggestions-list">
                        {suggestions.map((s) => (
                            <button key={s} type="button" className="chat-pill" onClick={() => onSuggestion(s)}>
                                <RichText text={s} />
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
